import React from "react";
import "../../nav/Navigation.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

interface Props {
    faIcon: IconProp,
    description: string,
    class: String
}

function FaSymbol(props: Props) {

    return (
        <>
            <div className={"user-tag d-inline-block mr-1"} style={{maxWidth: "250px"}}>
                <FontAwesomeIcon className={`animated zoomIn fa-solid ${props.class}`} icon={props.faIcon}/>
                <div className={"d-inline-block ml-2"}>{props.description}</div>
            </div>
        </>
    )
}

export default FaSymbol;
